import { IStyleProps } from './Interface'
import { makeStyles } from '@material-ui/core/styles'

export default makeStyles<{}, IStyleProps>({
  root: ({ publicMode }) => (publicMode ? { top: 'calc(25% - 50px)', position: 'fixed' } : {}),
  shareButton: {
    marginBottom: ({ open }) => (open ? 70 : 10),
    transition: 'all 0.3s ease'
  },
  configButton: {
    marginBottom: 10
  },
  markup: {
    padding: '10px',
    backgroundColor: '#dcdcdc',
    fontSize: '8px'
  },
  displaySocialMediaButtonText: {
    marginTop: '15px',
    lineHeight: '35px',
    verticalAlign: 'middle'
  },
  displaySocialMediaButtonLink: {
    height: '35px',
    verticalAlign: 'middle'
  }
})
